var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 101,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    y: 0.146,
    fill: "#FF7B03",
    rx: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.67 23.832a2.398 2.398 0 0 0-3.342.584l-.993 1.414-.753 4.63 5.742-3.4a2.398 2.398 0 0 0-.654-3.23v.002ZM22.436 72.672a2.398 2.398 0 1 0 3.924 2.757l24.837-35.362.992-6.098-4.39 2.6-25.363 36.103ZM53.655 24.295l-2.525-1.117a2.083 2.083 0 0 0-2.003.176l-5.842 3.943a2.068 2.068 0 0 0-.906 1.725v4.262c0 1.027.737 1.899 1.751 2.055l1.759.27 6.675-3.953 1.19-7.314a2.54 2.54 0 0 0-.1-.048l.001.001Zm-7.624 4.618a.621.621 0 1 1 0-1.243.621.621 0 0 1 0 1.243Zm3.617-.622a.621.621 0 1 1 0-1.242.621.621 0 0 1 0 1.242ZM78.808 31.982l-.295-.638a2.08 2.08 0 0 0-1.93-1.208l-15.38-1.505-6.998 4.144-1.446 8.894 4.81 7.715c.209.336.509.604.866.776l3.9 1.865c.416.199.887.254 1.338.156l2.404-.522a2.082 2.082 0 0 0 1.478-1.23l11.284-16.774a2.083 2.083 0 0 0-.03-1.673h-.001Zm-20.562 3.742a.621.621 0 1 1-1.221-.231.621.621 0 0 1 1.22.23Zm2.017 10.142a.621.621 0 1 1-1.221-.23.621.621 0 0 1 1.22.23Zm3.983-12.403a.621.621 0 1 1-1.221-.23.621.621 0 0 1 1.22.23Zm4.093 1.242a.621.621 0 1 1-1.221-.23.621.621 0 0 1 1.221.23Zm1.534-2.095a.621.621 0 1 1 1.221.23.621.621 0 0 1-1.22-.23Zm1.842 6.112a.621.621 0 1 1-1.221-.23.621.621 0 0 1 1.221.23Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 95.556,
    height: 95.556,
    x: 2.222,
    y: 2.369,
    stroke: "#fff",
    strokeOpacity: 0.36,
    strokeWidth: 4.444,
    rx: 47.778
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 65.889,
    height: 62.339,
    x: 17.556,
    y: 21.889,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4797_138801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4797_138801",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default ForwardRef;